import api from '@/api';

export const getters = {
  canView: state => organizationId => {
    if (state.permissions.organization && state.permissions.organization[organizationId]) {
      return state.permissions.organization[organizationId].can_view;
    }
    return false;
  },

  canCreateUsers: state => organizationId => {
    if (state.permissions.organization && state.permissions.organization[organizationId]) {
      return state.permissions.organization[organizationId].can_create_users;
    }
    return false;
  },

  canModify: state => organizationId => {
    if (state.permissions.organization && state.permissions.organization[organizationId]) {
      return state.permissions.organization[organizationId].can_modify;
    }
    return false;
  },

  canViewGroup: (state, gttrs, rootState, rootGetters) => groupId => {
    if (rootGetters.has_ux_tester_role_enabled) {
      if (state.permissions.group && state.permissions.group[groupId]) {
        return state.permissions.group[groupId].can_view;
      }

      return false;
    }

    const featureGroup = gttrs.getFeatureGroupById(groupId);

    return Boolean(featureGroup);
  },

  canCreateUsersInGroup: state => groupId => {
    if (state.permissions.group && state.permissions.group[groupId]) {
      return state.permissions.group[groupId].can_create_users;
    }

    return false;
  },

  canModifyGroup: state => groupId => {
    if (state.permissions.group && state.permissions.group[groupId]) {
      return state.permissions.group[groupId].can_modify;
    }

    return false;
  },

  canCreateUsersInSomeGroups: (state, gttrs) => groupIds => {
    return groupIds.some(groupId => gttrs.canCreateUsersInGroup(groupId));
  },

  canModifyLearner: (state, gttrs) => learner => {
    if (!learner) {
      return false;
    }

    const hasOrganizationPermissions = learner.organization && gttrs.canModify(learner.organization.id);

    const hasGroupPermissions = learner.group && gttrs.canModifyGroup(learner.group.id);

    return hasOrganizationPermissions || hasGroupPermissions;
  },

  isFetchingPermissions(state, gttrs, rootState, rootGetters) {
    return rootGetters['wait/is']('permissions.*');
  },
};

export const mutations = {
  UPDATE_PERMISSIONS(state, { permissions }) {
    if (!state.permissions) {
      state.permissions = {};
    }
    state.permissions.organization = {};
    permissions.forEach(permission => {
      state.permissions.organization[permission.id] = {
        can_view: permission.permissions.includes('can_view_organization'),
        can_create_users: permission.permissions.includes('can_add_to_organization'),
        can_modify: permission.permissions.includes('can_modify_organization'),
      };
    });
  },
  UPDATE_GROUP_PERMISSIONS(state, { permissions }) {
    if (!state.permissions) {
      state.permissions = {};
    }
    state.permissions.group = {};
    permissions.forEach(permission => {
      state.permissions.group[permission.id] = {
        can_view: permission.permissions.includes('can_view_group'),
        can_create_users: permission.permissions.includes('can_add_to_group'),
        can_modify: permission.permissions.includes('can_modify_group'),
      };
    });
  },
};

export const actions = {
  FETCH_PERMISSIONS: ({ commit, dispatch, state }) => {
    return new Promise(resolve => {
      if (state.permissions && state.permissions.organization) {
        return resolve(state.permissions.organization);
      }

      dispatch('wait/start', 'permissions.fetchOrganizationPermissions');

      return api
        .fetchPermissions()
        .then(permissions => {
          commit('UPDATE_PERMISSIONS', { permissions });
          dispatch('wait/end', 'permissions.fetchOrganizationPermissions');
          resolve(permissions);
        })
        .catch(() => dispatch('wait/end', 'permissions.fetchOrganizationPermissions'));
    });
  },

  FETCH_GROUP_PERMISSIONS: ({ commit, dispatch, state }) => {
    return new Promise(resolve => {
      if (state.permissions && state.permissions.group) {
        return resolve(state.permissions.group);
      }

      dispatch('wait/start', 'permissions.fetchGroupPermissions');

      return api
        .fetchGroupPermissions()
        .then(permissions => {
          commit('UPDATE_GROUP_PERMISSIONS', { permissions });
          dispatch('wait/end', 'permissions.fetchGroupPermissions');
          resolve(permissions);
        })
        .catch(() => dispatch('wait/end', 'permissions.fetchOrganizationPermissions'));
    });
  },
};

const state = {
  permissions: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
